import { Gallery, Photo, PhotoResponse } from '../services/api';

export type AlbumKind = 'match' | 'event';

export function albumKindFromId(galleryId: string, folderPath?: string | null): AlbumKind {
  if (folderPath?.includes('/events/')) {
    return 'event';
  }
  if (/^\d{4}_.+/.test(galleryId)) {
    return 'event';
  }
  return 'match';
}

export function photosFromResponse(
  response: Photo[] | PhotoResponse | null | undefined,
): Photo[] {
  if (!response) {
    return [];
  }
  if (Array.isArray(response)) {
    return response;
  }
  return response.photos || [];
}

export function totalPhotosFromResponse(
  response: Photo[] | PhotoResponse | null | undefined,
): number {
  if (!response) {
    return 0;
  }
  if (Array.isArray(response)) {
    return response.length;
  }
  return response.pagination?.total_photos ?? (response.photos?.length || 0);
}

export function buildDirectGallery(
  galleryId: string,
  kind: AlbumKind,
  photos: Photo[],
  totalPhotos: number,
  options?: { title?: string; description?: string; date?: string },
): Gallery {
  const fallbackTitle = galleryId.replace(/_/g, ' ');
  return {
    id: galleryId,
    title: options?.title || fallbackTitle,
    description: options?.description || fallbackTitle,
    coverImage: photos[0]?.imageUrl || null,
    photoCount: totalPhotos,
    date: options?.date || photos[0]?.date || '',
    folderPath: kind === 'event' ? `photos/events/${galleryId}` : `photos/matches/${galleryId}`,
  };
}
